import { createSlice } from "@reduxjs/toolkit";
import { fetchList } from "../action/knowledgebaseAction";

const initialState = {
  isLoading: false,
  list: [],
};

export const authSlice = createSlice({
  name: "knowledgebase",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch-list
    builder.addCase(fetchList.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchList.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.list =
        data?.map((item) => ({ ...item, text: item?.description || "" })) ?? [];

      state.isLoading = false;
    });
    builder.addCase(fetchList.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default authSlice.reducer;
